import {
  Fragment, useMemo } from "react";
  import { useTranslation } from "react-i18next";
  import {
  ImportOutlined,
  InboxOutlined,
  ScanOutlined,
  ExportOutlined,
  ArrowRightOutlined,
  RightOutlined,
} from "@ant-design/icons";
import "../style.css";

const iconByKey: Record<string, JSX.Element> = {
  receive: <ImportOutlined />,
  store: <InboxOutlined />,
  pick: <ScanOutlined />,
  ship: <ExportOutlined />,
};

interface WorkflowFlowProps {
  className?: string;
  variant?: "default" | "compact";
}

const WorkflowFlow = ({ className = "", variant = "default" }: WorkflowFlowProps) => {
  const { t } = useTranslation("wms");
  const isCompact = variant === "compact";

  const steps = useMemo(() => {
    const raw = t("workflow.steps", { returnObjects: true }) as unknown;
    if (!Array.isArray(raw)) return [];
    return raw as Array<{ key: string; label: string }>;
  }, [t]);

  return (
    <div
      className={[
        "dev-wms-workflow-grid",
        isCompact ? "dev-wms-workflow--compact" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <div className="dev-wms-workflow-track">
        {steps.map((step, idx) => (
          <Fragment key={step.key}>
            {isCompact ? (
              <div className="dev-wms-step-item">
                <div className={`dev-wms-step-card dev-wms-step-card--${step.key}`}>
                  <div className="dev-wms-step-icon">{iconByKey[step.key] ?? <RightOutlined />}</div>
                </div>
                <div className="dev-wms-step-title">{step.label}</div>
              </div>
            ) : (
              <div className={`dev-wms-step-card dev-wms-step-card--${step.key}`}>
                <div className="dev-wms-step-icon">{iconByKey[step.key] ?? <RightOutlined />}</div>
                <div className="dev-wms-step-title">{step.label}</div>
              </div>
            )}
            {idx < steps.length - 1 && (
              <div className="dev-wms-step-connector" aria-hidden>
                <ArrowRightOutlined />
              </div>
            )}
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default WorkflowFlow;
